<template>
    <div>
        <form-wrapper :validator="$v.model" class="form-wrapper">
            <form-group label="Customer Id" name="customerId">
                <md-input v-model.trim="model.customerId" />
            </form-group>
        </form-wrapper>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'UberKeys',
    props: {
        data: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            model: {
                customerId: '',
                clientId: '',
                clientSecret: '',
                webhookSecret: ''
            }
        };
    },
    validations() {
        return {
            model: {
                customerId: { required },
                clientId: { required },
                clientSecret: { required },
                webhookSecret: { required }
            }
        };
    },
    methods: {
        update() {
            this.$v.model.$touch();
            if (this.$v.model.$invalid) 
                return;

            this.$emit('onUpdate', { uberAccess: { ...this.model } });
        }
    },
    watch: {
        data(value) {
            Object.assign(this.model, value);
        }
    }
};
</script>
